import { RenovationQuestion } from '@hb/domain';
import { RenovationStoreService } from '@hb/modules/property/renovation-part/renovation-store.service';
import { RenovationComponent } from '@hb/modules/property/renovation-part/renovation/renovation.component';
import { RenovationAmountComponent } from '@hb/modules/property/renovation-part/renovation-amount/renovation-amount.component';
import { RenovationTipComponent } from '@hb/modules/property/renovation-part/renovation-tip/renovation-tip.component';
import { PreviousButtonComponent } from '@hb/modules/global/button';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'renovation-part',
    templateUrl: './renovation-part.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioModule,
        PreviousButtonComponent,
        RenovationComponent,
        RenovationAmountComponent,
        RenovationTipComponent
    ]
})
export class RenovationPartComponent implements OnInit, OnDestroy {
    protected readonly store = inject(RenovationStoreService);

    private activeQuestion: RenovationQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showRenovation(): boolean {
        return (
            this.activeQuestion === RenovationQuestion.RENOVATION_BUTTON ||
            (this.store.isActiveQuestion(RenovationQuestion.RENOVATION_BUTTON) && this.store.isSummary)
        );
    }
    showRenovationAmount(): boolean {
        return (
            (this.activeQuestion === RenovationQuestion.RENOVATION_AMOUNT_INPUT && !this.store.isSummary) ||
            (this.store.isActiveQuestion(RenovationQuestion.RENOVATION_AMOUNT_INPUT) && this.store.isSummary)
        );
    }
    showTip(): boolean {
        return this.activeQuestion === RenovationQuestion.RENOVATION_TIP && !this.store.isSummary;
    }
}
